import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

const BASE_URL = process.env.REACT_APP_BASE_URL;

export const outOfStockApi = createApi({
    reducerPath: "outOfStockApi",
    baseQuery: fetchBaseQuery({
        baseUrl: BASE_URL,
        prepareHeaders: (headers) => {
            const token = localStorage.getItem("token");
            if (token) {
                headers.set("authorization", `Bearer ${token}`);
            }
            return headers;
        },
    }),
    endpoints: (builder) => ({
 
        getOutOfStockProducts: builder.query({
            query: () => `/Product/all-outof-product`,
            providesTags: ["outOfStockData"],
        }),
 
        addProductQuantity: builder.mutation({
            query: (body) => ({
                url: `/Product/add-quantity`,
                method: "POST",
                body,
            }),
            invalidatesTags: ["outOfStockData"],
        }),

    }),
});

export const { 
    useGetOutOfStockProductsQuery,
    useAddProductQuantityMutation
} = outOfStockApi;
